import React, { useCallback, useEffect, useMemo, useState } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ReduxProvider } from "./core/redux"
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom"
import PreFormOfflineScreen from "./screen/PreScreenFormOffline"
import LoginContainer from "./container/LoginContainer"
//import AdminLayoutContainer from "./container/AdminLayoutContainer"
import { PrivateRouter } from "./routes/privateRoutes"
import { AdminRoutes } from "./routes/index"
import NpsContainer from "./container/NpsContainer"
import EvidencesContainer from "./container/EvidencesContainer"
import NewAdminContainer from "./container/NewAdminContainer"
import { ToastContainer } from "react-toastify"
import NotFoundContainer from "./container/NotFoundContainer"
import AssistanceLinkFormStepsContainer from "./container/AssistanceLinkFormStepsContainer"
import NewRelicScript from "./core/newRelic/script"
import { getPlatform } from "./core/utils/platform"
import EvaluationAssistanceContainer from "./container/EvaluationAssistanceContainer"
import MobileformContainer from "./container/MobileformContainer"
import { QRCodeLinkContainer } from "./container/QRCodeLinkContainer"
import { ChatProvider } from "./core/context/chatContext"
import "rc-tooltip/assets/bootstrap_white.css"
import "./assets/scss/main.scss"
import Send from "./core/communication"
import { useDispatch, useSelector } from "react-redux"
import { setData } from "./core/redux/app/Actions"
import { SystemInitializer } from "./core/components/SystemInitializer"
import { useNetworkState } from "react-use"
import NumberContainer from "./container/NumberContainer"

function AppContainer() {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <ChatProvider>
        {process.env.NODE_ENV !== "development" && <NewRelicScript />}
        <ReactQueryDevtools initialIsOpen={false} />
        <>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme="light"
            className="toastify-class"
            style={{ zIndex: 400000 }}
          />
          <Router history={History}>
            <SystemInitializer />
            <Routes>
              <Route element={<NewAdminContainer />}>
                {AdminRoutes().map(({ path, component }) => (
                  <Route
                    key={Math.random()}
                    path={path}
                    element={<PrivateRouter exact Component={component} path={path} />}
                  />
                ))}
              </Route>
              <Route path="/treinamento" element={<NpsContainer />} />
              <Route path="/qr-code/:id" element={<QRCodeLinkContainer />} />
              <Route path="/avaliar/:id" element={<EvaluationAssistanceContainer />} />
              <Route path="/open_form/:hashId" element={<AssistanceLinkFormStepsContainer />} />
              <Route path="/authentication/login" element={<LoginContainer />} />
              <Route path="/offline" element={<PreFormOfflineScreen />} />
              <Route path="/evidence/:userId" element={<EvidencesContainer />} />
              <Route path="/number/:id" element={<NumberContainer />} />
              <Route path="*" element={<NotFoundContainer />} />
              <Route path="/mobileform" element={<MobileformContainer />} />
              <Route path="/terms" element={<Navigate to="/terms.html" replace />} />
              <Route
                path="/form_details"
                element={<AssistanceLinkFormStepsContainer isOffline={true} />}
              />
            </Routes>
          </Router>
        </>
      </ChatProvider>
    </QueryClientProvider>
  )
}

function App() {
  useEffect(() => {
    if (getPlatform() === "2") {
      const root = document.documentElement
      root?.style.setProperty("--bg-color", "#f2f5f9")

      root?.style.setProperty("--primary-orange", "#0F408F")

      root?.style.setProperty("--primary-green", "#0F408F")

      // $primary-orange
      // root?.style.setProperty("--text-color", darkTheme ? "#fff" : "#262833");
    }
  }, [])

  return (
    <ReduxProvider>
      <AppContainer />
    </ReduxProvider>
  )
}

export default App
